import React from 'react';

export default function CopywritingIcon() {
	return (
		<svg width="100%" height="100%" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
			<mask id="mask0_1077_14838" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="41" height="41">
				<rect x="0.832031" y="0.819702" width="40" height="40" fill="#D9D9D9" />
			</mask>
			<g mask="url(#mask0_1077_14838)">
				<path d="M7.5 24.153V20.8197H19.1667V24.153H7.5ZM7.5 17.4863V14.153H25.8333V17.4863H7.5ZM7.5 10.8197V7.48633H25.8333V10.8197H7.5ZM22.5 34.153V29.028L31.7083 19.8613C31.9583 19.6113 32.2361 19.4308 32.5417 19.3197C32.8472 19.2085 33.1528 19.153 33.4583 19.153C33.7917 19.153 34.1111 19.2155 34.4167 19.3405C34.7222 19.4655 35 19.653 35.25 19.903L36.7917 21.4447C37.0139 21.6947 37.1875 21.9724 37.3125 22.278C37.4375 22.5836 37.5 22.8891 37.5 23.1947C37.5 23.5002 37.4444 23.8127 37.3333 24.1322C37.2222 24.4516 37.0417 24.7363 36.7917 24.9863L27.625 34.153H22.5ZM25 31.653H26.5833L31.625 26.5697L30.875 25.778L30.0833 25.028L25 30.0697V31.653ZM30.875 25.778L30.0833 25.028L31.625 26.5697L30.875 25.778Z" fill="#2D3846" />
			</g>
		</svg>
	);
}
